export default "__VITE_ASSET__a9676bbc__"